export const SET_ALERT = "setAlert";
export const SET_ALERT_VISIBILITY = "setAlertVisibility";
export const CLEAR_ALERTS = "clearAlerts";
